import React from 'react';

import {lighten} from 'polished';

import {colors} from '@app/styles/theme';

import {SortingIndicatorIcon} from './styled';

function iteratedValue(value?: boolean): boolean | undefined {
    switch (value) {
        case true:
            return false;
        case false:
            return undefined;
        default:
            return true;
    }
}

interface Props {
    value?: boolean; // isSortedDesc
    onChange: (value: boolean | undefined) => void;
}

export const Sorting = ({value = undefined, onChange}: Props) => {
    const handleChange = () => {
        if (onChange == null) {
            return;
        }

        onChange(iteratedValue(value));
    };

    return (
        <SortingIndicatorIcon
            color={value == null ? lighten(0.1, colors.textSecondary) : colors.textPrimary}
            isSortedDesc={value}
            name="sort"
            size={26}
            onClick={() => handleChange()}
        />
    );
};
